import { render, staticRenderFns } from "./TalentExpert.vue?vue&type=template&id=23266a30&scoped=true"
import script from "./TalentExpert.vue?vue&type=script&lang=js"
export * from "./TalentExpert.vue?vue&type=script&lang=js"
import style0 from "./TalentExpert.vue?vue&type=style&index=0&id=23266a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23266a30",
  null
  
)

export default component.exports